const filterUndefined = <T>(arr: Array<T | undefined | null>): Array<T> =>
  arr.filter((val) => val) as Array<T>;

export default filterUndefined;
